"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributionRecipients = exports.getQuantitiesList = void 0;
exports.getFirstItemId = getFirstItemId;
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var getQuantitiesList = function (start, end) {
    if (start === void 0) { start = 1; }
    if (end === void 0) { end = 100; }
    return new Array(end - start + 1).fill(0).map(function (_, i) {
        var val = i + start;
        return {
            label: val,
            value: val
        };
    });
};
exports.getQuantitiesList = getQuantitiesList;
function getFirstItemId(list, allowedValues) {
    var allowed = allowedValues
        ? list.filter(function (x) { return allowedValues.includes(x.id); })
        : list;
    if (allowed.length > 0 && allowed[0]) {
        return allowed[0].id;
    }
    return -1;
}
var distributionRecipients = function (data) {
    var recipients = Object.values(data).sort(function (a, b) { return userLens_1.getName.get(a.user).localeCompare(userLens_1.getName.get(b.user)); });
    return recipients;
};
exports.distributionRecipients = distributionRecipients;
